import { createContext } from 'react';

export interface IStoreUtilsContext {
  resetStore: () => void;
}

const StoreUtilsContext = createContext<IStoreUtilsContext | null>(null);

export default StoreUtilsContext;
